import {ChangeEvent, FC, ReactNode} from 'react';
//formik
import {FieldInputProps, FormikProps} from 'formik';
//mui
import {RadioProps, Radio as MuiRadio, FormControlLabel} from '@mui/material';
//constants
import {PRIMARY} from '@/utils/constants';
//icons
import {ReactComponent as CheckedIcon} from '@icons/rudiobutton-checked.svg';
import {ReactComponent as UncheckedIcon} from '@icons/rudiobutton-unchecked.svg';

export interface ExtendedRadioProps extends Omit<RadioProps, 'form'> {
	label?: ReactNode;
	field?: FieldInputProps<string | number>;
	form?: FormikProps<any>;
	isBooleanValue?: boolean;
	parentClassName?: string;
}

const Radio: FC<ExtendedRadioProps> = ({
	color,
	disabled = false,
	form,
	field,
	onChange,
	value,
	label,
	isBooleanValue,
	parentClassName,
	...rest
}) => {
	const changeHandler = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
		const {value} = event.target;

		if (onChange) {
			onChange(event, checked);
		} else if (form && field) {
			form.setFieldValue(field.name, isBooleanValue ? !field.value : value);
		}
	};

	return (
		<FormControlLabel
			value={value}
			className={parentClassName}
			label={label}
			control={
				<MuiRadio
					{...rest}
					checkedIcon={<CheckedIcon />}
					icon={<UncheckedIcon />}
					onChange={changeHandler}
					value={value}
					color={color || PRIMARY}
					disabled={disabled}
				/>
			}
		/>
	);
};

export default Radio;
